import { useSelector } from "react-redux";
import { ApplicationState } from "../rootStore";

export const useUserGroupReducer = () => useSelector((state: ApplicationState) => state.userGroup);
